import type { Extensions, JSONContent } from "@tiptap/core"
import type { Mark, Node } from "@tiptap/pm/model"

import { serializeChildrenToHTMLString } from "../../json/html-string/string.js"
import type { TiptapStaticRendererOptions } from "../../json/renderer.js"
import { renderToHTMLString } from "../html-string/html-string.js"

export function renderToText({
  doc,
  extensions,
  options,
}: {
  doc: JSONContent
  extensions: Extensions
  options?: Partial<TiptapStaticRendererOptions<string, Mark, Node>>
}) {
  return renderToHTMLString({
    content: doc,
    extensions,
    options: {
      nodeMapping: {
        bulletList({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        orderedList({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        listItem({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        paragraph({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        heading({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        codeBlock({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        blockquote({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        image({ node }) {
          return node.attrs.alt
        },
        hardBreak() {
          return " "
        },
        horizontalRule() {
          return ""
        },
        table({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        tableRow({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        tableHeader({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        tableCell({ children }) {
          return `${serializeChildrenToHTMLString(children)} `
        },
        ...options?.nodeMapping,
      },
      markMapping: {
        bold({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        italic({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        code({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        strike({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        underline({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        subscript({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        superscript({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        link({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        highlight({ children }) {
          return serializeChildrenToHTMLString(children)
        },
        ...options?.markMapping,
      },
      ...options,
    },
  })
}
